import api from '@/helpers/api'

export default {
    namespaced: true,
    state: () => ({
        config: { percentage: 20, is_active: true },
        loading: false,
        error: null
    }),
    getters: {
        config: (s) => s.config,
        loading: (s) => s.loading,
        error: (s) => s.error,
    },
    mutations: {
        setLoading(state, val) { state.loading = val },
        setError(state, val) { state.error = val },
        setConfig(state, cfg) { state.config = cfg },
    },
    actions: {
        async fetch({ commit }) {
            commit('setLoading', true)
            commit('setError', null)
            try {
                const { data } = await api.request('get', '/api/threshold')
                commit('setConfig', data)
            } catch (e) {
                commit('setError', e?.response?.data || e.message)
            } finally {
                commit('setLoading', false)
            }
        },
        async update({ commit }, payload) {
            commit('setLoading', true)
            commit('setError', null)
            try {
                const res = await api.request('post', '/api/threshold', {}, payload)
                commit('setConfig', res.data?.data)
                return res.data
            } catch (e) {
                commit('setError', e?.response?.data || e.message)
                throw e
            } finally {
                commit('setLoading', false)
            }
        }
    }
}


